export default __webpack_public_path__ + "static/home-page-preview-section-bg-deac16ad541bbd4e80ceebd80e16917d.jpg";